import axios from "axios";
import ReferralHash from "../../../../common/referral-hash";

import SecureLocalStorage from "secure-ls";

import {
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_FAILURE,
  GET_USER_DATA_SUCCESS,
  GET_USER_DATA_FAILURE,
  INCREMENT_STEP,
  INCREMENT_STEP_SUCCESS,
  INCREMENT_STEP_FAILURE,
  GET_REASONS_SUCCESS,
  GET_REASONS_FAILURE,
  CHOOSE_REASONS_SUCCESS,
  CHOOSE_REASONS_FAILURE,
  SET_DETAILS_SUCCESS,
  SET_DETAILS_FAILURE,
  SET_ABOUT_SUCCESS,
  SET_ABOUT_FAILURE,
  GET_INTERESTS_SUCCESS,
  GET_INTERESTS_FAILURE,
  CHOOSE_INTERESTS_SUCCESS,
  CHOOSE_INTERESTS_FAILURE,
  GET_AGE_SUCCESS,
  GET_AGE_FAILURE,
  CHOOSE_AGE_SUCCESS,
  CHOOSE_AGE_FAILURE,
  GET_DIVERSITY_SUCCESS,
  GET_DIVERSITY_FAILURE,
  CHOOSE_DIVERSITY_SUCCESS,
  CHOOSE_DIVERSITY_FAILURE,
  GET_MEMBERSHIPS_SUCCESS,
  GET_MEMBERSHIPS_FAILURE,
  CHOOSE_MEMBERSHIP_SUCCESS,
  CHOOSE_MEMBERSHIP_FAILURE,
  GET_CREDIT_CARD_SUCCESS,
  GET_CREDIT_CARD_FAILURE,
  SET_CREDIT_CARD_SUCCESS,
  SET_CREDIT_CARD_FAILURE,
  DELETE_CREDIT_CARD_SUCCESS,
  DELETE_CREDIT_CARD_FAILURE,
  GET_BILLING_ADDRESS_SUCCESS,
  GET_BILLING_ADDRESS_FAILURE,
  SET_BILLING_ADDRESS_SUCCESS,
  SET_BILLING_ADDRESS_FAILURE,
  GET_TERMS_AND_CONDITIONS_SUCCESS,
  GET_TERMS_AND_CONDITIONS_FAILURE,
  ACCEPT_TERMS_AND_CONDITIONS_SUCCESS,
  ACCEPT_TERMS_AND_CONDITIONS_FAILURE,
  RESEND_VERIFICATION_MESSAGE_SUCCESS,
  RESEND_VERIFICATION_MESSAGE_FAILURE,
  DELETE_DATA,
} from "features/application/form/redux/types";

export const getSettingsAction = () => (dispatch) => {
  axios({ method: "GET", url: "/api/v1/settings" })
    .then((response) =>
      dispatch({ type: GET_SETTINGS_SUCCESS, payload: response.data.data })
    )
    .catch((error) =>
      dispatch({ type: GET_SETTINGS_FAILURE, payload: error.response.status })
    );
};

export const getUserDataAction = (token) => (dispatch) => {
  const setAuthentication = new SecureLocalStorage({
    encodingType: "des",
    isCompression: false,
    encryptionSecret: "parlor-social-club",
  });
  const checkToken = token ? token : setAuthentication.get("token").data;

  axios({ method: "GET", url: "/api/v1/application/plans/with-preview" })
    .then((response) => {
      dispatch({ type: GET_MEMBERSHIPS_SUCCESS, payload: response.data.data });

      axios({
        method: "GET",
        url:
          "/api/v1/application/data" +
          (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : ""),
        headers: { Authorization: `Bearer ${checkToken.access}` },
      })
        .then((response) =>
          dispatch({ type: GET_USER_DATA_SUCCESS, payload: response.data.data })
        )
        .catch((error) =>
          dispatch({
            type: GET_USER_DATA_FAILURE,
            payload: error.response.status,
          })
        );
    })
    .catch((error) => {
      dispatch({
        type: GET_MEMBERSHIPS_FAILURE,
        payload: error.response.status,
      });
    });
};

export const incrementStepAction = (id) => (dispatch) => {
  dispatch({ type: INCREMENT_STEP, payload: id });

  axios({
    method: "PUT",
    url: "/api/v1/application/current-step",
    data: { current_step: id },
  })
    .then((response) =>
      dispatch({ type: INCREMENT_STEP_SUCCESS, payload: response.status })
    )
    .catch((error) =>
      dispatch({ type: INCREMENT_STEP_FAILURE, payload: error.response.status })
    );
};

export const getReasonsAction = () => (dispatch) => {
  axios({ method: "GET", url: "/api/v1/application/interests" })
    .then((response) =>
      dispatch({ type: GET_REASONS_SUCCESS, payload: response.data.data })
    )
    .catch((error) =>
      dispatch({ type: GET_REASONS_FAILURE, payload: error.response.status })
    );
};

export const chooseReasonsAction = (reasons) => (dispatch) => {
  axios({
    method: "POST",
    url: "/api/v1/application/interests",
    data: { ids: reasons },
  })
    .then((response) =>
      dispatch({ type: CHOOSE_REASONS_SUCCESS, payload: response.status })
    )
    .catch((error) =>
      dispatch({ type: CHOOSE_REASONS_FAILURE, payload: error.response.status })
    );
};

export const setDetailsAction = (details) => (dispatch) => {
  axios({ method: "POST", url: "/api/v1/application/details", data: details })
    .then((response) =>
      dispatch({ type: SET_DETAILS_SUCCESS, payload: response.status })
    )
    .catch((error) =>
      dispatch({ type: SET_DETAILS_FAILURE, payload: error.response })
    );
};

export const setAboutAction = (about) => (dispatch) => {
  axios({ method: "POST", url: "/api/v1/application/about", data: about })
    .then((response) =>
      dispatch({ type: SET_ABOUT_SUCCESS, payload: response.status })
    )
    .catch((error) =>
      dispatch({ type: SET_ABOUT_FAILURE, payload: error.response })
    );
};

export const getInterestsAction = () => (dispatch) => {
  axios({ method: "GET", url: "/api/v1/application/interest-groups" })
    .then((response) =>
      dispatch({ type: GET_INTERESTS_SUCCESS, payload: response.data.data })
    )
    .catch((error) =>
      dispatch({ type: GET_INTERESTS_FAILURE, payload: error.response.status })
    );
};

export const chooseInterestsAction = (interests) => (dispatch) => {
  axios({
    method: "POST",
    url: "/api/v1/application/interest-groups",
    data: { ids: interests },
  })
    .then((response) =>
      dispatch({ type: CHOOSE_INTERESTS_SUCCESS, payload: response.status })
    )
    .catch((error) =>
      dispatch({
        type: CHOOSE_INTERESTS_FAILURE,
        payload: error.response.status,
      })
    );
};

export const getAgeAction = () => (dispatch) => {
  axios({ method: "GET", url: "/api/v1/application/age-ranges" })
    .then((response) =>
      dispatch({ type: GET_AGE_SUCCESS, payload: response.data.data })
    )
    .catch((error) =>
      dispatch({ type: GET_AGE_FAILURE, payload: error.response.status })
    );
};

export const chooseAgeAction = (age) => (dispatch) => {
  axios({
    method: "POST",
    url: "/api/v1/application/age-ranges",
    data: { ids: age },
  })
    .then((response) =>
      dispatch({ type: CHOOSE_AGE_SUCCESS, payload: response.status })
    )
    .catch((error) =>
      dispatch({ type: CHOOSE_AGE_FAILURE, payload: error.response.status })
    );
};

export const getDiversityAction = () => (dispatch) => {
  axios({ method: "GET", url: "/api/v1/application/diversities" })
    .then((response) =>
      dispatch({ type: GET_DIVERSITY_SUCCESS, payload: response.data.data })
    )
    .catch((error) =>
      dispatch({ type: GET_DIVERSITY_FAILURE, payload: error.response.status })
    );
};

export const chooseDiversityAction = (diversity) => (dispatch) => {
  axios({
    method: "POST",
    url: "/api/v1/application/diversities",
    data: { ids: diversity },
  })
    .then((response) =>
      dispatch({ type: CHOOSE_DIVERSITY_SUCCESS, payload: response.status })
    )
    .catch((error) =>
      dispatch({
        type: CHOOSE_DIVERSITY_FAILURE,
        payload: error.response.status,
      })
    );
};

export const chooseMembershipAction = (id, isPayable, membership) => (
  dispatch
) => {
  axios({
    method: "POST",
    url: "/api/v1/application/plans",
    data: { id, use_payment: isPayable ? 1 : 0 },
  })
    .then((membershipsResponse) => {
      /* eslint-disable */
      fbq("track", "AddToCart", {
        content_id: membership.id,
        content_type: membership.is_premium
          ? "premium_membership"
          : "standard_membership",
        value_to_sum: membership.price,
        currency: JSON.stringify(membership.currency),
      });
      /* eslint-enable */

      axios({
        method: "GET",
        url:
          "/api/v1/application/data" +
          (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : ""),
      })
        .then((userDataResponse) => {
          dispatch({
            type: GET_USER_DATA_SUCCESS,
            payload: userDataResponse.data.data,
          });
          dispatch({
            type: CHOOSE_MEMBERSHIP_SUCCESS,
            payload: membershipsResponse.status,
          });
        })
        .catch((error) =>
          dispatch({
            type: GET_USER_DATA_FAILURE,
            payload: error.response.status,
          })
        );
    })
    .catch((error) =>
      dispatch({
        type: CHOOSE_MEMBERSHIP_FAILURE,
        payload: error.response.status,
      })
    );
};

export const getCreditCardAction = () => (dispatch) => {
  axios({ method: "GET", url: "/api/v1/application/cards" })
    .then((response) => {
      dispatch({ type: GET_CREDIT_CARD_SUCCESS, payload: response.data.data });

      response.data.data[0] &&
        axios({
          method: "GET",
          url: `/api/v1/application/cards/${response.data.data[0].id}`,
        })
          .then((response) =>
            dispatch({
              type: GET_BILLING_ADDRESS_SUCCESS,
              payload: response.data.data,
            })
          )
          .catch((error) =>
            dispatch({
              type: GET_BILLING_ADDRESS_FAILURE,
              payload: error.response.status,
            })
          );
    })
    .catch((error) =>
      dispatch({
        type: GET_CREDIT_CARD_FAILURE,
        payload: error.response.status,
      })
    );
};

export const setCreditCardAction = (creditCard) => (dispatch) => {
  axios({ method: "POST", url: "/api/v1/application/cards", data: creditCard })
    .then((response) =>
      dispatch({ type: SET_CREDIT_CARD_SUCCESS, payload: response.status })
    )
    .catch((error) =>
      dispatch({ type: SET_CREDIT_CARD_FAILURE, payload: error.response })
    );
};

export const deleteCreditCardAction = (id) => (dispatch) => {
  axios({ method: "DELETE", url: `/api/v1/application/cards/${id}` })
    .then((response) => {
      dispatch({ type: DELETE_CREDIT_CARD_SUCCESS, payload: response.status });
      window.location.reload();
    })
    .catch((error) =>
      dispatch({
        type: DELETE_CREDIT_CARD_FAILURE,
        payload: error.response.status,
      })
    );
};

export const setBillingAddressAction = (id, billingAddress, membership) => (
  dispatch
) => {
  axios({
    method: "PATCH",
    url: `/api/v1/application/cards/${id}`,
    data: billingAddress,
  })
    .then((response) => {
      /* eslint-disable */
      fbq("track", "AddPaymentInfo", {
        is_success: true,
      });

      fbq("track", "Purchase", {
        content_id: membership.id,
        content_type: membership.is_premium
          ? "premium_membership"
          : "standard_membership",
        value_to_sum: membership.price,
        currency: JSON.stringify(membership.currency),
      });
      /* eslint-enable */

      dispatch({
        type: SET_BILLING_ADDRESS_SUCCESS,
        payload: response.status,
      });
    })
    .catch((error) => {
      /* eslint-disable */
      fbq("track", "AddPaymentInfo", {
        is_success: false,
      });
      /* eslint-enable */

      dispatch({
        type: SET_BILLING_ADDRESS_FAILURE,
        payload: error.response,
      });
    });
};

export const getTermsAndConditionsAction = () => (dispatch) => {
  axios({ method: "GET", url: "/api/v1/application/terms" })
    .then((response) =>
      dispatch({
        type: GET_TERMS_AND_CONDITIONS_SUCCESS,
        payload: response.data.data,
      })
    )
    .catch((error) =>
      dispatch({
        type: GET_TERMS_AND_CONDITIONS_FAILURE,
        payload: error.response.status,
      })
    );
};

export const acceptTermsAndConditionsAction = () => (dispatch) => {
  axios({
    method: "POST",
    url: "/api/v1/application/terms",
    data: { accept: true },
  })
    .then((response) =>
      dispatch({
        type: ACCEPT_TERMS_AND_CONDITIONS_SUCCESS,
        payload: response.status,
      })
    )
    .catch((error) =>
      dispatch({
        type: ACCEPT_TERMS_AND_CONDITIONS_FAILURE,
        payload: error.response.status,
      })
    );
};

export const resendVerificationMessageAction = (email) => (dispatch) => {
  axios({
    method: "PATCH",
    url: "/api/v1/application/change-not-verified-email",
    data: { email },
  })
    .then((response) => {
      dispatch({
        type: RESEND_VERIFICATION_MESSAGE_SUCCESS,
        payload: response.status,
      });

      axios({
        method: "GET",
        url:
          "/api/v1/application/data" +
          (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : ""),
      })
        .then((response) =>
          dispatch({ type: GET_USER_DATA_SUCCESS, payload: response.data.data })
        )
        .catch((error) =>
          dispatch({
            type: GET_USER_DATA_FAILURE,
            payload: error.response.status,
          })
        );
    })
    .catch((error) =>
      dispatch({
        type: RESEND_VERIFICATION_MESSAGE_FAILURE,
        payload: error.response.status,
      })
    );
};

export const deleteDataAction = () => ({ type: DELETE_DATA });
